import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Returns the base URL for the public-facing site.
 * Uses REACT_APP_SITE_URL env var if set, otherwise falls back to window.location.origin.
 * This auto-adjusts between localhost (dev) and production (e.g. https://www.zapai.com.au).
 */
export function getSiteBaseUrl() {
  return process.env.REACT_APP_SITE_URL || window.location.origin;
}

/**
 * Returns the full public URL for a tenant's website.
 */
export function getTenantSiteUrl(slug) {
  return `${getSiteBaseUrl()}/s/${slug}`;
}
